import { styled } from "styled-components";
import { colors } from "@joinTrilo/ui/tokens";

export const ErrorContainer = styled.div`
    height: 60px;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    background-color: ${colors.warning};
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 10px;
    padding-right: 10px;
`;

export const ErrorIcon = styled.img`
    width: 25px;
    height: auto;
`;
export const ErrorMessage = styled.small`
    margin-left: 10px;
    line-height: 1.5;
`;
